import { PlannerValidation } from './PlannerValidation';
/**
 * Lowest hole to place a 55cm deep wirebasket in PLATSA and SMÅSTAD is hole 8 (7 in Core since they start at 0)
 */
export class WireBasketHeightValidation extends PlannerValidation {
    constructor(coreApi, wireBasketProductType) {
        super(coreApi, 'WireBasketHeightValidation');
        this.wireBasketProductType = wireBasketProductType;
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        return this.validate(entity, snapActionCandidate.endTransform, snapActionCandidate);
    }
    validate(entity, transform, snapActionCandidate) {
        if (this.coreApi.entities.isProductType(entity, this.wireBasketProductType) &&
            this.coreApi.entities.getEntityComSize(entity)?.depth === 550) {
            const hole = snapActionCandidate.hostConnector.hole;
            if (hole < 7) {
                // Core hole numbering starts at 0
                return this.validationFail('Can´t snap 55cm deep wirebasket below hole 8');
            }
        }
        return this.validationOK();
    }
}
//# sourceMappingURL=WireBasketHeightValidation.js.map